export default __webpack_public_path__ + "static/media/avatar_13.03353479.png";